/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

window.Vue = require('vue');

import './bulma';

import './script';

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
//  var SocialSharing = require('vue-social-sharing');
//  Vue.use(SocialSharing);
/*-----------------Plug-ins  ---------------*/
import VueSlickCarousel from 'vue-slick-carousel'
import VueTabs from 'vue-nav-tabs'
import VueLazyload from 'vue-lazyload';
import VueSweetalert2 from 'vue-sweetalert2';
import VueTranslate from 'vue-translate-plugin';
import { Carousel3d, Slide } from 'vue-carousel-3d';
import LightGallery from 'vue-light-gallery';
import {Tabs, Tab} from 'vue-tabs-component';
/*-----------------General Components ---------------*/

import StickyHeader from './components/GeneralComponents/StickyHeader';
import SlotForm from './components/GeneralComponents/SlotForm';
import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion';
import Alert from './components/GeneralComponents/Alert';
import Uploader from './components/GeneralComponents/Uploader.vue';

/*-----------------Site Components ---------------*/

import Videos from './components/SiteComponents/Videos';
import Blog from './components/SiteComponents/Blog';
import Gallery from './components/SiteComponents/Gallery';
import Activities from './components/SiteComponents/Activities';
import BranchesContact from './components/SiteComponents/BranchesContact';
import AchievementsCarousel from './components/SiteComponents/AchievementsCarousel';
import Calendar from './components/SiteComponents/Calendar';
import Jobs from './components/SiteComponents/Jobs';

import './components/GeneralComponents/plugins/lightgallery/js/lightgallery.js';
import 'lg-zoom.js';
import 'lg-thumbnail.js';
import 'lg-share.js';
import 'lg-video.js';





/*-------------USES---------------*/
Vue.component('Carousel3d', Carousel3d);
Vue.component('Slide', Slide);
Vue.use(VueTranslate);
Vue.component('alert', Alert);
Vue.use(VueSweetalert2);
Vue.use(VueTabs);
Vue.use(LightGallery);

/*----------- Lazyload ------------*/
Vue.use(VueLazyload, {
    preLoad: 100,
    error: '/front/img/illustrations/no_pictures.svg',
    loading: '/front/img/illustrations/img_loader.svg',
    attempt: 1,
});
/*-----------Global Variables ----------*/
import translate from './components/SiteComponents/translation/general.json';
Vue.mixin({
    data: function() {
        return {
            translate: translate
        }
    },
    locales: translate,
})

export {
    VueSlickCarousel,
    Slide,
    StickyHeader,
    SlotForm,
    BulmaAccordion,
    BulmaAccordionItem,
    Videos,
    Blog,
    Gallery,
    Activities,
    BranchesContact,
    AchievementsCarousel,
    Calendar,
    Uploader,
    Jobs,
    Tabs,
    Tab
}
const app = new Vue({
    el: '#app',
    components: {
        VueSlickCarousel,
        Slide,
        StickyHeader,
        SlotForm,
        BulmaAccordion,
        BulmaAccordionItem,
        Videos,
        Blog,
        Gallery,
        Activities,
        BranchesContact,
        AchievementsCarousel,
        Calendar,
        Uploader,
        Jobs,
        Tabs,
        Tab
    }
});
